export default __webpack_public_path__ + "static/media/image-placeholder.3c0a422b.jpg";